export const FILTERS_LIST_LOADING = "FILTERS_LIST_LOADING";
export const FILTERS_LIST_SUCCESS = "FILTERS_LIST_SUCCESS";
